export const APIUrl = "https://munyabrew.ru/api/coasters";
export const siteUrl = "https://munyabrew.ru/";